import { render } from "./CreatePhoto.vue?vue&type=template&id=b5217940&scoped=true"
import script from "./CreatePhoto.vue?vue&type=script&lang=js"
export * from "./CreatePhoto.vue?vue&type=script&lang=js"

import "./CreatePhoto.vue?vue&type=style&index=0&id=b5217940&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5217940"]])

export default __exports__